import { configureStore } from '@reduxjs/toolkit'
import albumsReducer from '../containers/albums/meta/slices';

const store = configureStore({
        reducer: {
            album:albumsReducer
        }
});

// Expose store to legacy Backbone/jQuery code so non-React utilities (e.g. common_utils.js)
// can dispatch Redux actions without importing ES modules.
const photoOrg = window.photoOrg || {};
window.photoOrg = photoOrg;
photoOrg.albumsStore = store;

export default store;


